import { render, staticRenderFns } from "./gc-field-radio.vue?vue&type=template&id=f87dd94c"
import script from "./gc-field-radio.vue?vue&type=script&lang=js"
export * from "./gc-field-radio.vue?vue&type=script&lang=js"
import style0 from "./gc-field-radio.vue?vue&type=style&index=0&id=f87dd94c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports